import { useState } from "react";
import { Link } from "react-router-dom";
import { adminRequest } from "lib/adminSiteApi";
import { ActionForm, Loading, Record, useRemote } from "../workspace/Controls";
export default function Enrollments({ id }) {
  const [tick, setTick] = useState(0),
    [filters, setFilters] = useState({
      customerId: "",
      courseId: "",
      status: "",
    }),
    [after, setAfter] = useState("");
  const query = new URLSearchParams(
    Object.entries({ ...filters, after, limit: "25" }).filter(([, v]) => v),
  );
  const state = useRemote(
    "/admin/course-enrollments" + (id ? "/" + id : "?" + query),
    tick,
  );
  const history = useRemote(
    id ? "/admin/course-enrollments/" + id + "/history" : null,
    tick,
  );
  return (
    <>
      <h2>Course enrollments</h2>
      {!id && (
        <ActionForm
          title="Grant complimentary course access"
          description="This grants the approved course or bundle for its configured access duration without taking payment. Live seats are reserved. Enter the website customer and course IDs."
          schema={{
            type: "object",
            properties: {
              courseId: { type: "string", pattern: "^[A-Za-z0-9_-]{1,128}$" },
              customerId: { type: "string", pattern: "^[A-Za-z0-9_-]{1,128}$" },
              reason: { type: "string", minLength: 1, maxLength: 1000 },
              confirmed: { type: "boolean" },
            },
            required: ["courseId", "customerId", "reason", "confirmed"],
          }}
          initial={{
            courseId: "",
            customerId: "",
            reason: "",
            confirmed: false,
          }}
          submit={(body, key) =>
            adminRequest("/admin/course-enrollments", {
              method: "POST",
              body,
              key,
            })
          }
          onDone={() => setTick((t) => t + 1)}
        />
      )}
      {!id && (
        <div className="aw-fields">
          {Object.entries(filters).map(([key, value]) => (
            <label key={key}>
              {key}
              <input
                value={value}
                onChange={(e) => {
                  setFilters({ ...filters, [key]: e.target.value });
                  setAfter("");
                }}
              />
            </label>
          ))}
        </div>
      )}
      <Loading state={state}>
        {state.data &&
          (id ? (
            <>
              <Link to={"/admin/customers/" + state.data.customerId}>
                Customer
              </Link>
              {state.data.sourceType === "purchase" && (
                <Link to={"/admin/orders/" + state.data.sourceId}>
                  {" "}
                  · Order and payment review
                </Link>
              )}
              <Record data={state.data} />
              <ActionForm
                title="Change course access"
                description="Revoking or cancelling stops lesson and file access. Cancellation releases a live seat. This does not refund money. Restoring purchased access requires a paid order. Confirm the consequence before saving."
                schema={{
                  type: "object",
                  properties: {
                    status: { enum: ["active", "revoked", "cancelled"] },
                    reason: { type: "string", minLength: 1, maxLength: 1000 },
                    confirmed: { type: "boolean" },
                  },
                  required: ["status", "reason", "confirmed"],
                }}
                initial={{ status: "revoked", reason: "", confirmed: false }}
                submit={(body, key) =>
                  adminRequest("/admin/course-enrollments/" + id, {
                    method: "POST",
                    body,
                    key,
                  })
                }
                onDone={() => setTick((t) => t + 1)}
              />
              <h3>Access history</h3>
              <Loading state={history}>
                {history.data && <Record data={history.data.items} />}
              </Loading>
            </>
          ) : (
            <>
              <table className="aw-table">
                <thead>
                  <tr>
                    <th>Course</th>
                    <th>Customer</th>
                    <th>Status</th>
                    <th>Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {state.data.items.map((row) => (
                    <tr key={row.id}>
                      <td>
                        <Link to={"/admin/course-enrollments/" + row.id}>
                          {row.title}
                        </Link>
                      </td>
                      <td>{row.customerId}</td>
                      <td>{row.status}</td>
                      <td>{row.paymentStatus}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="aw-row">
                <button onClick={() => setAfter("")} disabled={!after}>
                  First page
                </button>
                <button
                  disabled={!state.data.next}
                  onClick={() => setAfter(state.data.next)}
                >
                  Next
                </button>
              </div>
            </>
          ))}
      </Loading>
    </>
  );
}
